/* A PASSWORD BOX WITH ITS OWN EYE.

   Max, 2026-10-07: "ê ko có nút con mắt để xem pw hẻ", then "Login cũng chưa có con mắt … thêm
   nhé". Five boxes wanted one between them — three on Login (sign in, and the two on the
   set-your-password card) and two on the reset screen — so it is written once. Five copies of a
   toggle is five places for one of them to keep `type="password"` after the eye says otherwise.

   EACH BOX OWNS ITS OWN STATE, which is the decision and not an implementation detail. The pairs
   exist to be COMPARED; one switch revealing both turns them into the same question asked twice,
   while revealing one and leaving the other hidden is what somebody actually does when the form
   says they do not match.

   HIDDEN BY DEFAULT, always. The dots are there for the person standing behind you, and a field
   that remembers it was revealed would carry that choice to a screen they can see.

   `type="button"`, because a <button> inside a <form> submits by default — without it the first
   peek would try to sign in, or save, with a half-typed password. */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';

/* `name` IS NOT DECORATION HERE. Login's handleChange reads `e.target.name` and writes
   `values[name]`, so a field that forwards no name sets `values[undefined]` and the password
   never reaches the form — the sign-in button would have gone quiet with nothing on screen to
   say why. It defaults to the id, which is what every caller here wants anyway. */
function PasswordField({ id, name, labelId, value, onChange, placeholder, autoComplete,
                         required = false, what }) {
    const { t } = useTranslation();
    const [shown, setShown] = useState(false);
    // `what` arrives already in the reader's language (callers pass t('xAuth.what…')); none = "password".
    const whatText = what || t('xAuth.whatPassword');
    return (
        <span className="login-field-wrap">
            <input
                id={id}
                name={name || id}
                type={shown ? 'text' : 'password'}
                aria-labelledby={labelId}
                autoComplete={autoComplete}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="login-field"
                required={required}
            />
            <button
                type="button"
                className="login-eye"
                aria-pressed={shown}
                aria-label={t(shown ? 'xAuth.hideWhat' : 'xAuth.showWhat', { what: whatText })}
                title={shown ? t('xAuth.hide') : t('xAuth.show')}
                onClick={() => setShown((p) => !p)}
            >
                {shown ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </span>
    );
}

export default PasswordField;
